import { render, staticRenderFns } from "./DanhSachLogOtp.vue?vue&type=template&id=3dc154b0&scoped=true&"
import script from "./DanhSachLogOtp.vue?vue&type=script&lang=js&"
export * from "./DanhSachLogOtp.vue?vue&type=script&lang=js&"
import style0 from "./DanhSachLogOtp.vue?vue&type=style&index=0&id=3dc154b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc154b0",
  null
  
)

export default component.exports